var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.state.pipelines && _setup.state.stages)?_c(_setup.LeadPipelineStagePane,{attrs:{"current-stage":_setup.state.currentStage,"stages":_setup.state.stages,"pipelines":_setup.state.pipelines},on:{"input":_setup.stageSelected}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }